import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c07d2fa4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "app" }
const _hoisted_2 = { class: "bg-dark" }
const _hoisted_3 = { class: "custom-container-md text-center p-0" }
const _hoisted_4 = {
  id: "header",
  class: "carousel slide carousel-fade",
  "data-bs-ride": "carousel"
}
const _hoisted_5 = { class: "carousel-inner" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "navbar navbar-expand-md navbar-dark bg-primary sticky-top" }
const _hoisted_8 = { class: "container" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Shuntaro Sumita's website")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbar-content",
  "aria-controls": "navbar-content",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_11 = {
  class: "collapse navbar-collapse",
  id: "navbar-content"
}
const _hoisted_12 = { class: "navbar-nav me-auto" }
const _hoisted_13 = { class: "navbar-nav" }
const _hoisted_14 = { class: "nav-item dropdown" }
const _hoisted_15 = {
  class: "nav-link dropdown-toggle active",
  href: "#",
  id: "languageDropdown",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_16 = {
  class: "dropdown-menu",
  "aria-labelledby": "languageDropdown"
}
const _hoisted_17 = { class: "py-4 bg-primary text-light" }
const _hoisted_18 = { class: "container text-center" }
const _hoisted_19 = { class: "nav justify-content-center mb-3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("small", null, "Copyright © Shuntaro Sumita")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageInfos, (imageInfo, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass(imageInfo.active ? 'carousel-item active' : 'carousel-item')
              }, [
                _createElementVNode("img", {
                  class: "img-fluid",
                  src: imageInfo.src,
                  alt: imageInfo.text
                }, null, 8, _hoisted_6)
              ], 2))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("nav", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_link, {
          class: "navbar-brand",
          to: _ctx.pages[_ctx.activelang].top.url
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["to"]),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("ul", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages[_ctx.activelang], (page, name) => {
              return (_openBlock(), _createElementBlock("li", {
                key: name,
                class: "nav-item"
              }, [
                _createVNode(_component_router_link, {
                  class: _normalizeClass(page.active ? 'nav-link active' : 'nav-link'),
                  to: page.url
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(page.title), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "to"])
              ]))
            }), 128))
          ]),
          _createElementVNode("ul", _hoisted_13, [
            _createElementVNode("li", _hoisted_14, [
              _createElementVNode("a", _hoisted_15, [
                _createVNode(_component_font_awesome_icon, { icon: ['fa-solid', 'globe'] })
              ]),
              _createElementVNode("div", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langInfos, (langInfo, index) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: index,
                    class: "dropdown-item",
                    to: langInfo.url
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(langInfo.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view, { onActivate: _ctx.setActive }, null, 8, ["onActivate"])
    ]),
    _createElementVNode("footer", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("ul", _hoisted_19, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.langInfos, (langInfo, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "nav-item"
            }, [
              _createVNode(_component_router_link, {
                class: "nav-link text-light",
                to: langInfo.url
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(langInfo.text), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
        ]),
        _hoisted_20
      ])
    ])
  ]))
}